import React from "react";
import { useParams } from "react-router-dom";
import { Loader } from "rsuite";
import { useGetBlogsQuery } from "../../../entities/Activity/activityApi";
import type { ActivityType } from "../../../entities/Activity/types/activityType";
import { ActivityRouter } from "../../../features/activities/components/ActivityRouter/ActivityRouter";
import { formatDate } from "../../../shared/helpers/formatData";
import styles from "./BlogDetails.module.scss";

export const BlogDetail = () => {
	const { id } = useParams();
	const { data = [], isLoading, isError } = useGetBlogsQuery(null);

	if (isLoading) {
		return <Loader center content="loading" vertical />;
	}

	if (isError) {
		return <div>something went wrong</div>;
	}

	const blog = data.find((post) => post._id === id);
	return (
		<div className={styles.blogContainer}>
			<div className={styles.header}>
				<img
					src={blog?.image}
					alt="Blog Banner"
					className={styles.bannerImage}
				/>
				<h1 className={styles.title}>{blog?.title}</h1>
			</div>
			<div className={styles.metadata}>
				<p className={styles.author}>
					Written by <span>Nazim Turdiyev</span>
				</p>
				<p className={styles.date}>{formatDate(blog?.createdAt)}</p>
			</div>
			<div className={styles.content}>
				<ActivityRouter
					activity={
						blog as unknown as { details: { customActivities: ActivityType[] } }
					}
				/>
			</div>
			<div className={styles.footer}>
				<p>
					Want to learn more? Follow me on{" "}
					<a
						href="https://github.com/nazimkazim"
						target="_blank"
						rel="noopener noreferrer"
						className={styles.link}
					>
						GitHub
					</a>{" "}
					or connect on{" "}
					<a
						href="https://linkedin.com/in/nazim-turdiyev-3b1b0718b"
						target="_blank"
						rel="noopener noreferrer"
						className={styles.link}
					>
						LinkedIn
					</a>
					.
				</p>
			</div>
		</div>
	);
};
